export const DEFAULT_BORDER_WIDTH = `0.0625rem`;